module.exports = __webpack_public_path__ + "static/media/location-icon.7a9ba785.svg";